module.exports = __webpack_public_path__ + "img/stock0.54dbe1f5.png";